import React from 'react';
import { Modal, Button } from 'components/ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const alignRight = {
  float: 'right',
};

const ZoomIntegrationInstructionsModal = ({
  modalVisible,
  toggleModalVisible,
}) => (
  <Modal
    shown={modalVisible}
    className="ZoomIntegrationInstructionsModal"
    onDismiss={toggleModalVisible}
    canClickAway
    enableFloatingDismiss
  >
    <div className="ZoomIntegrationInstructionsModal-content">
      <h2 className="fz-28 mb-20 lh-1">
        {t('in_person_training.new_event.zoom_integration_modal.title')}
      </h2>
      <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
        {t('in_person_training.new_event.zoom_integration_modal.description')}
      </Text>
      <div>
        <ol className="mt-20 ml-20">
          <li
            dangerouslySetInnerHTML={{
              __html: t(
                'in_person_training.new_event.zoom_integration_modal.step_1',
              ),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t(
                'in_person_training.new_event.zoom_integration_modal.step_2',
              ),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t(
                'in_person_training.new_event.zoom_integration_modal.step_3',
              ),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t(
                'in_person_training.new_event.zoom_integration_modal.step_4',
              ),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t(
                'in_person_training.new_event.zoom_integration_modal.step_5',
              ),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t(
                'in_person_training.new_event.zoom_integration_modal.step_6',
              ),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t(
                'in_person_training.new_event.zoom_integration_modal.step_7',
              ),
            }}
          />
          <li
            dangerouslySetInnerHTML={{
              __html: t(
                'in_person_training.new_event.zoom_integration_modal.step_8',
              ),
            }}
          />
        </ol>
      </div>
      <Button style={alignRight} onClick={toggleModalVisible}>
        {t('common.ok')}
      </Button>
    </div>
  </Modal>
);

export default ZoomIntegrationInstructionsModal;
